/**
 * Enllaços a apren.ai (abans sele.ai): els exàmens de Catalunya digitalitzats per practicar-los
 * dinàmics des del mòbil, comprovar les respostes al moment i estudiar amb IA.
 *
 * examenselectivitat continua sent el web de referència de Catalunya a Google: a apren.ai les
 * pàgines de Catalunya surten amb noindex i enllacen cap aquí (aprenAI: seoCopy.YIELDED_REGIONS,
 * amb la mateixa taula al revés). Si una assignatura canvia de nom a apren.ai, el slug vell hi fa
 * un 301 al bo, perquè el número del final és el que compta.
 */
/**
 * Interruptor: false = tot com abans (anuncis de sele.ai, sense la línia d'apren.ai).
 * Encendre-ho només quan apren.ai tingui desplegades les URL de la jerarquia (si no, fan 404)
 */
export const APRENAI_ON = false;
export const SELEAI_URL = 'https://sele.ai/?step=5&studyType=4&center=220&course=2032';

export const APRENAI_URL = 'https://apren.ai';
const CATALUNYA = `${APRENAI_URL}/selectividad-ebau-evau-o-pau-3/selectivitat-pau-catalunya-234`;

/** subject_path d'examenselectivitat → slug de l'assignatura a apren.ai */
const SUBJECTS = {
  biologia: 'biologia-891108', fisica: 'fisica-891109', alemany: 'aleman-891110', frances: 'frances-891111',
  angles: 'ingles-891112', italia: 'italiano-891113', matematiques: 'matematicas-ii-891114', quimica: 'quimica-891116',
  'economia-de-l-empresa': 'economia-de-la-empresa-5-891117', 'dibuix-artistic': 'dibujo-artistico-891118',
  'historia-de-l-art': 'historia-del-arte-891119', grec: 'griego-ii-891120',
  'historia-de-la-filosofia': 'historia-de-la-filosofia-891121', llati: 'latin-ii-891122', historia: 'historia-de-espana-891123',
  geografia: 'geografia-891125', 'dibuix-tecnic': 'dibujo-tecnico-ii-891126', disseny: 'diseno-891127',
  'fonaments-de-les-arts': 'fundamentos-artisticos-891128', 'llengua-castellana': 'lengua-castellana-y-literatura-ii-891129',
  'matematiques-cs': 'matematicas-aplicadas-a-las-ciencias-sociales-ii-891130', 'analisi-musical': 'analisis-musical-891131',
  'literatura-catalana': 'literatura-catalana-891132', 'ciencies-de-la-terra': 'ciencias-de-la-tierra-y-del-medio-ambiente-891133',
  'llengua-catalana': 'lengua-catalana-y-literatura-ii-2-891134', 'literatura-castellana': 'literatura-castellana-891135',
  'tecnologia-industrial': 'tecnologia-industrial-891136', 'arts-esceniques': 'artes-escenicas-904119',
  'ciencies-generals': 'ciencias-generales-904120', 'cor-tecnica-vocal': 'coro-y-tecnica-vocal-904121',
  'dibuix-tecnic-aplicat-arts-disseny': 'dibujo-tecnico-aplicado-a-las-artes-plasticas-y-al-diseno-904122',
  'historia-de-la-musica-i-de-la-dansa': 'historia-de-la-musica-y-de-la-danza-904123',
  'literatura-dramatica': 'literatura-dramatica-904124', 'moviments-culturals-i-artistics': 'movimientos-culturales-y-artisticos-904125',
  'teniques-d-expressio-graficoplastiques': 'tecnicas-de-expresion-grafico-plastica-904126',
};

/** La pàgina de l'assignatura a apren.ai (o la de Catalunya si no hi és), amb l'origen per a l'analítica */
export function aprenAiUrl(subjectPath, campaign = 'enllac') {
  if (!APRENAI_ON) return SELEAI_URL;
  const slug = subjectPath && SUBJECTS[subjectPath];
  return `${slug ? `${CATALUNYA}/asignatura/${slug}` : CATALUNYA}?utm_source=examenselectivitat&utm_medium=referral&utm_campaign=${campaign}`;
}

/** Hi ha exàmens d'aquesta assignatura a apren.ai */
export function hasAprenAi(subjectPath) {
  return APRENAI_ON && !!(subjectPath && SUBJECTS[subjectPath]);
}
